// Invoice payment-terms constants, in a module with no imports at all.
//
// They are separate from base.receivables.helper.ts — which owns every other AR rule and would be the obvious
// home — for one hard reason: these two numbers are read by CLIENT components. The Finance Center help copy, the
// Revenue agent's section rules and the dashboard's past-due card all quote them in prose rather than typing the
// number into a sentence, which is the whole point of their existing. base.receivables.helper.ts evaluates
// `Prisma.raw(...)` and `Prisma.sql` at module scope, and the browser build of the Prisma client throws on those
// ("raw is unable to run in this browser environment"), so anything importing it from a client component breaks.
// Keep this file free of imports and the two graphs stay separate.
//
// Both are re-exported from @utils/quoteUtils, which is where the app imports them from.

// Grace period applied to an issued invoice that has no explicit due date: it becomes due this many days after
// its anchor date. Both server code (the effective-due-date helpers and their SQL twins, AccountingService
// aging, the dashboard's past-due card) and the client copy explaining the rule read this, and a number
// duplicated across those would silently drift.
export const UNDATED_INVOICE_GRACE_DAYS = 30;

// Days allowed for payment of an AIA pay application, by the job's billing terms. Exported for the same reason
// as the grace period above: the value appears in the TypeScript due-date helper, its SQL twin, and the help
// text explaining how AIA due dates are derived, and a number written out in three places drifts.
export const AIA_BILLING_TERM_DAYS = { NET_30: 30, NET_60: 60 } as const;
